import { createClient } from 'contentful'
import { CONTENTFUL_SPACE } from '../config/constants'
import envConfig from '../config/ui'

const contentfulConfig = {
  space: CONTENTFUL_SPACE,
  accessToken: envConfig.contentful.token,
  host: envConfig.contentful.endpoint,
  resolveLinks: true
}

const contentfulClient = createClient(contentfulConfig)

export default contentfulClient